import { Routes, buildOrganizationRoute } from '@shared/constants/routes';
import { useAppSelector } from '@shared/redux';
import { authSelectors } from '@shared/redux/ducks/auth';
import { Navigate, useLocation, useParams } from 'react-router-dom';

interface LegacyOrganizationRedirectProps {
  targetRoute: string;
}

export const LegacyOrganizationRedirect = ({ targetRoute }: LegacyOrganizationRedirectProps) => {
  const currentOrganization = useAppSelector(authSelectors.selectCurrentOrganizationInfo);
  const userInfo = useAppSelector(authSelectors.selectUserInfo);
  const location = useLocation();
  const params = useParams();

  const fallbackOrganizationId =
    currentOrganization?.id || userInfo?.organizations?.[0]?.id || null;

  if (!fallbackOrganizationId) {
    return <Navigate to={Routes.profile.organization.root} replace />;
  }

  return (
    <Navigate
      to={{
        pathname: buildOrganizationRoute(targetRoute, fallbackOrganizationId, params),
        search: location.search,
        hash: location.hash,
      }}
      replace
    />
  );
};
